import { api } from '@/services/api';
import type {
  LoginParams,
  LoginResult,
  UserInfo,
  RefreshTokenParams,
} from '@/types/auth';

/** 前端仅做 Base64 编码，后端解码后做 MD5 校验 */
function encodePassword(plain: string): string {
  return btoa(unescape(encodeURIComponent(plain)));
}

/**
 * Login
 */
export const login = (params: LoginParams) => {
  const encodedPassword = encodePassword(params.password);
  return api.post<LoginResult>('/passport/login', {
    username: params.name,
    password: encodedPassword,
  });
};

/**
 * Logout
 */
export const logout = (refreshToken: string) => {
  return api.delete('/passport/logout', {
    params: { refresh_token: refreshToken },
  });
};

/**
 * Refresh token
 */
export const refreshToken = (params: RefreshTokenParams) => {
  return api.put<LoginResult>('/passport/refresh-token', params);
};

/**
 * Get user profile
 */
export const getProfile = () => {
  return api.get<UserInfo>('/profile');
};

/**
 * Get system rules/permissions
 */
export const getSystemRules = () => {
  return api.get<{ list: string[] }>('/system/rules');
};
